"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RtcConnectionFactory_1 = __importDefault(require("./RtcConnectionFactory"));
class RtcConnectionsStore {
    constructor() {
        this.connections = new Map();
    }
    exists(user) {
        return this.connections.has(user);
    }
    get(user) {
        var _a;
        return (_a = this.connections.get(user)) !== null && _a !== void 0 ? _a : null;
    }
    create(user) {
        const connection = RtcConnectionFactory_1.default.createNew(user);
        this.connections.set(user, connection);
        return connection;
    }
    remove(user) {
        const connection = this.connections.get(user);
        if (!connection) {
            return false;
        }
        connection.close();
        this.connections.delete(user);
        return true;
    }
}
const rtcConnectionsStore = new RtcConnectionsStore();
exports.default = rtcConnectionsStore;
